import { render } from "./StaffPage_report.vue?vue&type=template&id=bb7b77fe&scoped=true"
import script from "./StaffPage_report.vue?vue&type=script&lang=js"
export * from "./StaffPage_report.vue?vue&type=script&lang=js"

import "./StaffPage_report.vue?vue&type=style&index=0&id=bb7b77fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb7b77fe"]])

export default __exports__